
// import React, { useState, useEffect, useCallback } from "react";
// import styles from "./dailyorder.module.css";
// import { dailyOrderApi } from "../../../api/home/dailyOrderApi";
// import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend
// } from 'chart.js';
// import { Bar } from 'react-chartjs-2';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// const MONTHS = [
//     { label: 'January',   value: '1'  },
//     { label: 'February',  value: '2'  },
//     { label: 'March',     value: '3'  },
//     { label: 'April',     value: '4'  },
//     { label: 'May',       value: '5'  },
//     { label: 'June',      value: '6'  },
//     { label: 'July',      value: '7'  },
//     { label: 'August',    value: '8'  },
//     { label: 'September', value: '9'  },
//     { label: 'October',   value: '10' },
//     { label: 'November',  value: '11' },
//     { label: 'December',  value: '12' }
// ];

// // Years from current down to 2024
// const buildYears = () => {
//     const current = new Date().getFullYear();
//     const years = [];
//     for (let y = current; y >= 2024; y--) {
//         years.push(y.toString());
//     }
//     return years;
// };

// const DailyOrder = () => {
//     const years = buildYears();

//     // Default to current year and month
//     const now = new Date();
//     const [selectedYear,  setSelectedYear]  = useState(now.getFullYear().toString());
//     const [selectedMonth, setSelectedMonth] = useState((now.getMonth() + 1).toString());
//     const [activeFilters, setActiveFilters] = useState({});
//     const [chartData,     setChartData]     = useState(null);
//     const [userRole,      setUserRole]      = useState(null);
//     const [loading,       setLoading]       = useState(false);
//     const [error,         setError]         = useState(null);

//     // ─── Fetch ─────────────────────────────────────────────────
//     const fetchDailyOrderData = async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             // Take first value from multi-select (same pattern as SalesVsCogs)
//             const filtersToSend = {};
//             Object.entries(activeFilters).forEach(([key, val]) => {
//                 if (val) {
//                     const first = val.split(',')[0];
//                     if (first) filtersToSend[key] = first;
//                 }
//             });

//             const response = await dailyOrderApi.getDailyOrderData(
//                 selectedYear, selectedMonth, filtersToSend
//             );

//             const data   = response?.data || response;
//             const roleId = response?.roleId;

//             setUserRole(roleId);
//             prepareChartData(data);
//         } catch (err) {
//             setError('Failed to load daily order data');
//             console.error('❌ Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchDailyOrderData();
//     }, [selectedYear, selectedMonth, activeFilters]);

//     // ─── Chart ─────────────────────────────────────────────────
//     const prepareChartData = (data) => {
//         if (!data || data.length === 0) { setChartData(null); return; }

//         setChartData({
//             labels: data.map(item => item.date),
//             datasets: [{
//                 label: 'Daily Orders',
//                 data: data.map(item => item.orderCount),
//                 orderValues: data.map(item => item.orderValue),
//                 backgroundColor: '#0078d4',
//                 borderColor: '#0078d4',
//                 borderWidth: 1,
//                 borderRadius: 4,
//                 maxBarThickness: 40
//             }]
//         });
//     };

//     // ─── Stable filter callback ────────────────────────────────
//     const handleFiltersChange = useCallback((newFilters) => {
//         setActiveFilters(newFilters);
//     }, []);

//     const getMonthName = () =>
//         MONTHS.find(m => m.value === selectedMonth)?.label || '';

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { display: false },
//             tooltip: {
//                 callbacks: {
//                     title: (context) =>
//                         `${getMonthName()} ${context[0].label}, ${selectedYear}`,
//                     label: (context) => {
//                         const orderCount = context.parsed.y;
//                         const orderValue = context.dataset.orderValues[context.dataIndex];
//                         const formatted = '₹' + (orderValue || 0).toLocaleString('en-IN', {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2
//                         });
//                         return ['Orders: ' + orderCount, 'Order Value: ' + formatted];
//                     }
//                 }
//             }
//         },
//         scales: {
//             x: {
//                 grid: { display: false },
//                 title: {
//                     display: true, text: 'Date',
//                     font: { size: 12, weight: 'bold' }
//                 }
//             },
//             y: {
//                 beginAtZero: true,
//                 grid: { color: '#e5e7eb' },
//                 title: {
//                     display: true, text: 'Number of Orders',
//                     font: { size: 12, weight: 'bold' }
//                 },
//                 ticks: {
//                     stepSize: 5,
//                     callback: (value) => Number.isInteger(value) ? value : ''
//                 }
//             }
//         }
//     };

//     return (
//         <div className={styles.componentWrapper}>
//             <div className={styles.headerSection}>
//                 <h2 className={styles.componentTitle}>
//                     Daily Orders — {getMonthName()} {selectedYear}
//                 </h2>

//                 <div className={styles.filtersSection}>
//                     <div className={styles.filterGroup}>
//                         <label className={styles.filterLabel}>Year:</label>
//                         <select
//                             value={selectedYear}
//                             onChange={(e) => setSelectedYear(e.target.value)}
//                             className={styles.select}
//                         >
//                             {years.map(y => (
//                                 <option key={y} value={y}>{y}</option>
//                             ))}
//                         </select>
//                     </div>

//                     <div className={styles.filterGroup}>
//                         <label className={styles.filterLabel}>Month:</label>
//                         <select
//                             value={selectedMonth}
//                             onChange={(e) => setSelectedMonth(e.target.value)}
//                             className={styles.select}
//                         >
//                             {MONTHS.map(m => (
//                                 <option key={m.value} value={m.value}>{m.label}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>
//             </div>

//             {/* Same filters component as SalesVsCogs and Category */}
//             <SalesCogsFilters
//                 userRoleId={userRole}
//                 onFiltersChange={handleFiltersChange}
//             />

//             {error && <div className={styles.errorMessage}>{error}</div>}

//             {loading && (
//                 <div className={styles.loadingContainer}>
//                     <div className={styles.loadingSpinner} />
//                     <span>Loading chart data...</span>
//                 </div>
//             )}

//             {!loading && chartData && (
//                 <div className={styles.chartContainer}>
//                     <Bar data={chartData} options={chartOptions} />
//                 </div>
//             )}

//             {!loading && !chartData && !error && (
//                 <div className={styles.noDataMessage}>
//                     No order data available for {getMonthName()} {selectedYear}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default DailyOrder;


import React, { useState, useEffect, useCallback, useRef } from "react";
import styles from "./dailyorder.module.css";
import { dailyOrderApi } from "../../../api/home/dailyOrderApi";
import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
import * as XLSX from 'xlsx';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MONTHS = [
    { label: 'January',   value: '1'  },
    { label: 'February',  value: '2'  },
    { label: 'March',     value: '3'  },
    { label: 'April',     value: '4'  },
    { label: 'May',       value: '5'  },
    { label: 'June',      value: '6'  },
    { label: 'July',      value: '7'  },
    { label: 'August',    value: '8'  },
    { label: 'September', value: '9'  },
    { label: 'October',   value: '10' },
    { label: 'November',  value: '11' },
    { label: 'December',  value: '12' }
];

const buildYears = () => {
    const current = new Date().getFullYear();
    const years = [];
    for (let y = current; y >= 2024; y--) years.push(y.toString());
    return years;
};

const ITEMS_PER_PAGE = 15;

// ── Order Detail Modal ───────────────────────────────────────────────────────
const OrderDetailModal = ({ isOpen, onClose, date, monthName, year, filters }) => {
    const [orders,       setOrders]       = useState([]);
    const [loading,      setLoading]      = useState(false);
    const [error,        setError]        = useState(null);
    const [searchTerm,   setSearchTerm]   = useState('');
    const [currentPage,  setCurrentPage]  = useState(1);

    // Fetch orders when modal opens
    useEffect(() => {
        if (!isOpen || !date) return;
        setSearchTerm('');
        setCurrentPage(1);
        fetchOrders();
    }, [isOpen, date]);

    const fetchOrders = async () => {
        try {
            setLoading(true);
            setError(null);
            // date is the day number (e.g. 15)
            // Extract year/month/day from the clicked bar
            const [d, m, y] = [date, filters._month, filters._year];
            const data = await dailyOrderApi.getDailyOrderDetail(
                filters._year, filters._month, date, filters
            );
            setOrders(data || []);
        } catch (err) {
            console.error('❌ Error fetching order detail:', err);
            setError('Failed to load orders');
        } finally {
            setLoading(false);
        }
    };

    // ── Search — all fields except date and amount ───────────────────────────
    const filteredOrders = orders.filter(order => {
        if (!searchTerm.trim()) return true;
        const q = searchTerm.toLowerCase();
        return (
            String(order.orderNum        || '').toLowerCase().includes(q) ||
            String(order.orderStatus     || '').toLowerCase().includes(q) ||
            String(order.customerPONo    || '').toLowerCase().includes(q) ||
            String(order.customerName    || '').toLowerCase().includes(q) ||
            String(order.contactPerson   || '').toLowerCase().includes(q) ||
            String(order.salesEmployee   || '').toLowerCase().includes(q) ||
            String(order.paymentTerms    || '').toLowerCase().includes(q)
        );
    });

    // ── Pagination ───────────────────────────────────────────────────────────
    const totalPages   = Math.ceil(filteredOrders.length / ITEMS_PER_PAGE);
    const paginatedOrders = filteredOrders.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    // Reset to page 1 on search
    useEffect(() => { setCurrentPage(1); }, [searchTerm]);

    // ── Excel export ─────────────────────────────────────────────────────────
    const handleExportExcel = () => {
        const exportData = filteredOrders.map(o => ({
            'Order No':        o.orderNum,
            'Status':          o.orderStatus,
            'Customer PO No':  o.customerPONo  || 'N/A',
            'Order Date':      o.orderDate,
            'Order Time':      o.orderTime     || 'N/A',
            'Customer Name':   o.customerName,
            'Contact Person':  o.contactPerson || 'N/A',
            'Delivery Date':   o.deliveryDate  || 'N/A',
            'Sales Employee':  o.salesEmployee || 'N/A',
            'Sub Total':       o.subtotal,
            'Tax Total':       o.taxTotal,
            'Total Amount':    o.totalAmount,
            'Payment Terms':   o.paymentTerms  || 'N/A',
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');
        XLSX.writeFile(wb, `orders_${year}_${monthName}_${date}.xlsx`);
    };

    const formatCurrency = (n) =>
        '₹' + (n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>

                {/* Header */}
                <div className={styles.modalHeader}>
                    <div>
                        <h2 className={styles.modalTitle}>
                            Orders — {date} {monthName} {year}
                        </h2>
                        <span className={styles.modalSubtitle}>
                            {filteredOrders.length} order{filteredOrders.length !== 1 ? 's' : ''}
                        </span>
                    </div>
                    <button className={styles.modalClose} onClick={onClose}>✕</button>
                </div>

                {/* Search + Export */}
                <div className={styles.modalToolbar}>
                    <div className={styles.modalSearchWrapper}>
                        <span className={styles.modalSearchIcon}>🔍</span>
                        <input
                            type="text"
                            placeholder="Search by order no, status, customer, contact, sales employee, payment terms..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            className={styles.modalSearchInput}
                        />
                        {searchTerm && (
                            <button
                                className={styles.modalSearchClear}
                                onClick={() => setSearchTerm('')}
                            >✕</button>
                        )}
                    </div>
                    <button
                        className={styles.exportButton}
                        onClick={handleExportExcel}
                        disabled={filteredOrders.length === 0}
                    >
                        📊 Export Excel
                    </button>
                </div>

                {/* Table */}
                <div className={styles.modalTableWrapper}>
                    {loading ? (
                        <div className={styles.modalLoading}>
                            <div className={styles.loadingSpinner} />
                            <span>Loading orders...</span>
                        </div>
                    ) : error ? (
                        <div className={styles.modalError}>{error}</div>
                    ) : paginatedOrders.length === 0 ? (
                        <div className={styles.modalEmpty}>
                            {searchTerm ? 'No orders match your search' : 'No orders for this date'}
                        </div>
                    ) : (
                        <table className={styles.modalTable}>
                            <thead>
                                <tr>
                                    <th className={styles.modalTh}>Order No</th>
                                    <th className={styles.modalTh}>Status</th>
                                    <th className={styles.modalTh}>Customer PO No</th>
                                    <th className={styles.modalTh}>Order Date</th>
                                    <th className={styles.modalTh}>Order Time</th>
                                    <th className={styles.modalTh}>Customer Name</th>
                                    <th className={styles.modalTh}>Contact Person</th>
                                    <th className={styles.modalTh}>Delivery Date</th>
                                    <th className={styles.modalTh}>Sales Employee</th>
                                    <th className={styles.modalTh}>Sub Total</th>
                                    <th className={styles.modalTh}>Tax Total</th>
                                    <th className={styles.modalTh}>Total Amount</th>
                                    <th className={styles.modalTh}>Payment Terms</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedOrders.map((order, i) => (
                                    <tr key={i} className={styles.modalTr}>
                                        <td className={styles.modalTd}>{order.orderNum}</td>
                                        <td className={styles.modalTd}>
                                            <span className={`${styles.statusBadge} ${
                                                order.orderStatus === 'Open'      ? styles.statusOpen :
                                                order.orderStatus === 'Closed'    ? styles.statusClosed :
                                                order.orderStatus === 'Cancelled' ? styles.statusCancelled :
                                                ''
                                            }`}>
                                                {order.orderStatus}
                                            </span>
                                        </td>
                                        <td className={styles.modalTd}>{order.customerPONo  || 'N/A'}</td>
                                        <td className={styles.modalTd}>{order.orderDate}</td>
                                        <td className={styles.modalTd}>{order.orderTime     || 'N/A'}</td>
                                        <td className={styles.modalTd}>{order.customerName}</td>
                                        <td className={styles.modalTd}>{order.contactPerson || 'N/A'}</td>
                                        <td className={styles.modalTd}>{order.deliveryDate  || 'N/A'}</td>
                                        <td className={styles.modalTd}>{order.salesEmployee || 'N/A'}</td>
                                        <td className={styles.modalTd}>{formatCurrency(order.subtotal)}</td>
                                        <td className={styles.modalTd}>{formatCurrency(order.taxTotal)}</td>
                                        <td className={styles.modalTd}>{formatCurrency(order.totalAmount)}</td>
                                        <td className={styles.modalTd}>{order.paymentTerms  || 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* Pagination */}
                {!loading && totalPages > 1 && (
                    <div className={styles.modalPagination}>
                        <span className={styles.paginationInfo}>
                            Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
                            {Math.min(currentPage * ITEMS_PER_PAGE, filteredOrders.length)} of {filteredOrders.length}
                        </span>
                        <div className={styles.paginationControls}>
                            <button
                                className={styles.paginationBtn}
                                onClick={() => setCurrentPage(1)}
                                disabled={currentPage === 1}
                            >First</button>
                            <button
                                className={styles.paginationBtn}
                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                            >Prev</button>
                            <span className={styles.pageNumber}>
                                {currentPage} / {totalPages}
                            </span>
                            <button
                                className={styles.paginationBtn}
                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                            >Next</button>
                            <button
                                className={styles.paginationBtn}
                                onClick={() => setCurrentPage(totalPages)}
                                disabled={currentPage === totalPages}
                            >Last</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// ── Main DailyOrder component ────────────────────────────────────────────────
const DailyOrder = () => {
    const years   = buildYears();
    const chartRef = useRef(null);

    const now = new Date();
    const [selectedYear,  setSelectedYear]  = useState(now.getFullYear().toString());
    const [selectedMonth, setSelectedMonth] = useState((now.getMonth() + 1).toString());
    const [activeFilters, setActiveFilters] = useState({});
    const [chartData,     setChartData]     = useState(null);
    const [userRole,      setUserRole]      = useState(null);
    const [loading,       setLoading]       = useState(false);
    const [error,         setError]         = useState(null);

    // Modal state
    const [modalOpen,    setModalOpen]    = useState(false);
    const [clickedDay,   setClickedDay]   = useState(null);

    // ─── Fetch chart data ──────────────────────────────────────────────────
    const fetchDailyOrderData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const filtersToSend = {};
            Object.entries(activeFilters).forEach(([key, val]) => {
                if (val) {
                    const first = val.split(',')[0];
                    if (first) filtersToSend[key] = first;
                }
            });

            const response = await dailyOrderApi.getDailyOrderData(
                selectedYear, selectedMonth, filtersToSend
            );

            const data   = response?.data   || response;
            const roleId = response?.roleId;

            setUserRole(roleId);
            prepareChartData(data);
        } catch (err) {
            setError('Failed to load daily order data');
            console.error('❌ Error:', err);
        } finally {
            setLoading(false);
        }
    }, [selectedYear, selectedMonth, activeFilters]);

    useEffect(() => { fetchDailyOrderData(); }, [fetchDailyOrderData]);

    const prepareChartData = (data) => {
        if (!data || data.length === 0) { setChartData(null); return; }
        setChartData({
            labels: data.map(item => item.date),
            datasets: [{
                label: 'Daily Orders',
                data: data.map(item => item.orderCount),
                orderValues: data.map(item => item.orderValue),
                backgroundColor: data.map(() => '#0078d4'),
                hoverBackgroundColor: data.map(() => '#005a9e'),
                borderColor: '#0078d4',
                borderWidth: 1,
                borderRadius: 4,
                maxBarThickness: 40
            }]
        });
    };

    const handleFiltersChange = useCallback((newFilters) => {
        setActiveFilters(newFilters);
    }, []);

    const getMonthName = () => MONTHS.find(m => m.value === selectedMonth)?.label || '';

    // ─── Bar click handler ─────────────────────────────────────────────────
    const handleBarClick = useCallback((event) => {
        if (!chartRef.current) return;
        const chart = chartRef.current;
        const elements = chart.getElementsAtEventForMode(
            event.nativeEvent, 'nearest', { intersect: true }, false
        );
        if (elements.length === 0) return;

        const index   = elements[0].index;
        const dayNum  = chartData?.labels?.[index]; // e.g. 15
        if (!dayNum) return;

        setClickedDay(dayNum);
        setModalOpen(true);
    }, [chartData]);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // Make bars clickable — cursor pointer on hover
        onHover: (event, elements) => {
            event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    title: (context) =>
                        `${getMonthName()} ${context[0].label}, ${selectedYear}`,
                    label: (context) => {
                        const orderCount = context.parsed.y;
                        const orderValue = context.dataset.orderValues?.[context.dataIndex];
                        const formatted  = '₹' + (orderValue || 0).toLocaleString('en-IN', {
                            minimumFractionDigits: 2, maximumFractionDigits: 2
                        });
                        return ['Orders: ' + orderCount, 'Order Value: ' + formatted];
                    }
                }
            }
        },
        scales: {
            x: {
                grid: { display: false },
                title: { display: true, text: 'Date', font: { size: 12, weight: 'bold' } }
            },
            y: {
                beginAtZero: true,
                grid: { color: '#e5e7eb' },
                title: { display: true, text: 'Number of Orders', font: { size: 12, weight: 'bold' } },
                ticks: {
                    stepSize: 5,
                    callback: (value) => Number.isInteger(value) ? value : ''
                }
            }
        }
    };

    // Filters passed to modal — include year/month so modal can fetch correctly
    const modalFilters = {
        ...activeFilters,
        _year:  selectedYear,
        _month: selectedMonth,
    };

    return (
        <div className={styles.componentWrapper}>
            <div className={styles.headerSection}>
                <h2 className={styles.componentTitle}>
                    Daily Orders — {getMonthName()} {selectedYear}
                </h2>
                <div className={styles.filtersSection}>
                    <div className={styles.filterGroup}>
                        <label className={styles.filterLabel}>Year:</label>
                        <select
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            className={styles.select}
                        >
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className={styles.filterGroup}>
                        <label className={styles.filterLabel}>Month:</label>
                        <select
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            className={styles.select}
                        >
                            {MONTHS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            <SalesCogsFilters
                userRoleId={userRole}
                onFiltersChange={handleFiltersChange}
            />

            {error && <div className={styles.errorMessage}>{error}</div>}

            {loading && (
                <div className={styles.loadingContainer}>
                    <div className={styles.loadingSpinner} />
                    <span>Loading chart data...</span>
                </div>
            )}

            {!loading && chartData && (
                <div className={styles.chartContainer}>
                    <Bar
                        ref={chartRef}
                        data={chartData}
                        options={chartOptions}
                        onClick={handleBarClick}
                    />
                </div>
            )}

            {!loading && !chartData && !error && (
                <div className={styles.noDataMessage}>
                    No order data available for {getMonthName()} {selectedYear}
                </div>
            )}

            {/* Order Detail Modal */}
            <OrderDetailModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                date={clickedDay}
                monthName={getMonthName()}
                year={selectedYear}
                filters={modalFilters}
            />
        </div>
    );
};

export default DailyOrder;